<template>
  <div class="p-config">
    <div v-if="offers_sizes && offers_sizes.length > 0" class="default-select">
      <select class="default-select__select" @change="getOffer" v-model="config.size">
        <option v-for="(size, key) in offers_sizes" :key="size" :value="key">{{ /[^xх\d]/.test(size) ? size : 'Размер ' + size }}</option>
      </select>
    </div>
    <div v-if="this.showMobileSizeTable === 'Y'" class="p-table p-table--mobile">
      <div class="p-table__title" data-popup="#size">Таблица размеров</div>
    </div>
    <div v-if="offers_colors && offers_colors.length > 0" class="default-select">
      <select class="default-select__select color color--1" @change="getOffer" v-model="config.color" data-placeholder="Цвет товара"></select>
    </div>
    <div v-if="glass_colors && glass_colors.length > 0" class="default-select">
      <select class="default-select__select color color--2" @change="getOffer" v-model="config.glass_color" data-placeholder="Цвет стекла"></select>
    </div>
    <div v-if="profile_colors && profile_colors.length > 0" class="default-select">
      <select class="default-select__select color color--3" @change="getOffer" v-model="config.profile_color" data-placeholder="Цвет профиля"></select>
    </div>
    <div v-if="orientations && orientations.length > 0" class="default-select">
      <select class="default-select__select" @change="getOffer" v-model="config.orientation">
        <option v-for="(orientation, key) in orientations" :key="orientation" :value="key">{{ orientation }}
                                                                                           ориентация
        </option>
      </select>
    </div>
<!--    <div v-if="easy_clean === 'Y'" class="default-checkbox">-->
<!--      <input ref="easy_clean" v-model="moduleEasyClean.easy_clean" class="default-checkbox__input" type="checkbox" name="id" id="id-1" :disabled="easy_clean_default === 'Y'">-->
<!--      <label class="default-checkbox__label" for="id-1">{{ moduleEasyClean.name }}<span>{{-->
<!--          moduleEasyClean.info-->
<!--                                                                                        }}</span></label>-->
<!--      <span v-if="easy_clean_default === 'Y'" class="default-checkbox__description">{{-->
<!--          moduleEasyClean.titleIfIncluded-->
<!--                                                                                    }}</span>-->
<!--      <span v-else class="default-checkbox__description">+ {{ moduleEasyClean.price }} руб. к сумме заказа</span>-->
<!--    </div>-->
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name     : "OfferSelects",
  props    : {
    colors              : {
      type : Object
    },
    offers_sizes        : {
      type : Array
    },
    glass_colors        : {
      type : Array
    },
    profile_colors      : {
      type : Array
    },
    offers_colors       : {
      type : Array
    },
    orientations        : {
      type : Array
    },
    generic_id          : {
      type : Number
    },
    url                 : {
      type : String
    },
    easy_clean          : {
      type : String
    },
    easy_clean_default  : {
      type : String
    },
    showMobileSizeTable : {
      type : String
    }
  },
  computed : {
    ...mapState([
      "moduleEasyClean"
    ])
  },
  data()
  {
    return {
      config : {
        orientation   : 0,
        glass_color   : 0,
        profile_color : 0,
        color         : 0,
        size          : 0
      }
    };
  },
  methods : {
    getOffer()
    {
      let valid = true;
      for(let configKey in this.config)
      {
        if(isNaN(this.config[configKey]))
        {
          valid = false;
        }
      }
      if(!valid)
      {
        return;
      }
      let formData = new FormData();
      if(this.orientations && this.orientations[this.config.orientation])
      {
        formData.append("orientation", this.orientations[this.config.orientation]);
      }
      if(this.glass_colors && this.glass_colors[this.config.glass_color])
      {
        formData.append("glass_color", this.glass_colors[this.config.glass_color]);
      }
      if(this.profile_colors && this.profile_colors[this.config.profile_color])
      {
        formData.append("profile_color", this.profile_colors[this.config.profile_color]);
      }
      if(this.offers_colors && this.offers_colors[this.config.color])
      {
        formData.append("color", this.offers_colors[this.config.color]);
      }
      if(this.offers_sizes && this.offers_sizes[this.config.size])
      {
        formData.append("size", this.offers_sizes[this.config.size]);
      }
      formData.append("generic_id", this.generic_id.toString());
      fetch("/api/catalog/product/offers/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(result =>
      {
        if(!result.success)
        {
          window.toast.error(result.message);
        }
        else if(this.url !== result.data)
        {
          location.href = result.data;
        }
      });
    },
    getColorsArray( colorsIds )
    {
      let colorsArray = [];
      if(!colorsIds || colorsIds.length < 1) return colorsArray;
      for(let color of colorsIds)
      {
        colorsArray.push({
          name  : this.colors[color].NAME,
          color : this.colors[color].PREVIEW_TEXT
        });
      }
      return colorsArray;
    }
  },
  created()
  {
    this.moduleEasyClean.easy_clean = this.easy_clean_default === "Y";
    let colorsOffers                = this.getColorsArray(this.offers_colors);
    let colorsGlass                 = this.getColorsArray(this.glass_colors);
    let colorsProfiles              = this.getColorsArray(this.profile_colors);
    document.addEventListener("DOMContentLoaded", () =>
    {
      if(colorsOffers.length > 0)
      {
        window.initColorSelect(colorsOffers, ".color--1");
      }
      if(colorsGlass.length > 0)
      {
        window.initColorSelect(colorsGlass, ".color--2");
      }
      if(colorsProfiles.length > 0)
      {
        window.initColorSelect(colorsProfiles, ".color--3");
      }
    });
  }
};
</script>

<style scoped>

</style>